export default  function NotFound(){
    return (<>

        <div className="text-center my-5">
            <h1>Page Not Found</h1>
        </div>
    </>)
}